export const RPC = 'rpc';
export const UPLOAD = 'upload';
export const DOWNLOAD = 'download';

export const APP_AUTH = 'app';
export const USER_AUTH = 'user';
export const TEAM_AUTH = 'team';
export const NO_AUTH = 'noauth';
